function getCookie(name) {
  let matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([.$?*|{}()[]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setFontSize(fontSize) {
  document.querySelector('html').style.fontSize = fontSize;
}

function setColor(value) {
  const [colorName, bgName] = value.split(',');
  const fontSize = document.querySelector('html').style.fontSize;
  document.documentElement.setAttribute("style", `
                                                  --main-color: ${bgName};
                                                  --second-color: ${colorName};
                                                  --third-color: ${colorName};
                                                  --white-text: ${colorName};`
                                                  
  );
  document.querySelector('html').style.fontSize = fontSize;
}

function enableDisableImage(enable) {
  if (enable) {
    document.querySelectorAll('img').forEach(e => {
      e.classList.add('tvsu-lowVisionDisplayNone');
    })
  } else {
    document.querySelectorAll('img').forEach(e => {
      e.classList.remove('tvsu-lowVisionDisplayNone');
    })
  }
  const btn = document.querySelector('#img-onoff-btn');
  if (!btn) { return; }
  // const enableText = document.querySelector('html').getAttribute('lang') === 'en' ? 'Включить' : 'Enable';
  // const disableText = document.querySelector('html').getAttribute('lang') === 'en' ? 'Выключить' : 'Disable';
  const btn_enable = document.querySelector('#img-onoff-text-enable');
  const btn_disable = document.querySelector('#img-onoff-text-disable');
  // btn.innerHTML = enable ? enableText : disableText;
  if(enable) {
    btn_enable.classList.remove('d-none')
    btn_disable.classList.add('d-none')
  } else {
    btn_enable.classList.add('d-none')
    btn_disable.classList.remove('d-none')
  }
}

function setLineHeight(value) {
  if (value === '1') {
    document.querySelector('body').classList.remove('tvsu-lowVisionEnableMiddleLineHeight');
    document.querySelector('body').classList.remove('tvsu-lowVisionEnableBigLineHeight');
  }
  if (value === '2') {
    document.querySelector('body').classList.add('tvsu-lowVisionEnableMiddleLineHeight');
    document.querySelector('body').classList.remove('tvsu-lowVisionEnableBigLineHeight');
  }
  if (value === '3') {
    document.querySelector('body').classList.remove('tvsu-lowVisionEnableMiddleLineHeight');
    document.querySelector('body').classList.add('tvsu-lowVisionEnableBigLineHeight');
  }
}

function setfontFamily(value) {
  if (value === '1') {
    document.querySelector('body').classList.remove('tvsu-Arial');
    document.querySelector('body').classList.remove('tvsu-Times');
  }
  if (value === '2') {
    document.querySelector('body').classList.add('tvsu-Arial');
    document.querySelector('body').classList.remove('tvsu-Times');
  }
  if (value === '3') {
    document.querySelector('body').classList.remove('tvsu-Arial');
    document.querySelector('body').classList.add('tvsu-Times');
  }
}


function init() {
  const params = new URLSearchParams(window.location.search);
  if (params.get('accessible') === 'true') {
    document.cookie = 'lowVision=on; path=/';
  }
  
  const enableLowVision = getCookie('lowVision');
  if (enableLowVision && enableLowVision === 'on') {
    document.querySelector('body').classList.add('tvsu-lowVisionColorEnable');
    const panel = document.getElementById('sv_wrapper');
    panel.style.display = 'flex';

    const lowVisionFontSize = getCookie('lowVisionFontSize') ? getCookie('lowVisionFontSize') : '16px';
    const lowVisionColorName = getCookie('lowVisionColorName') ? getCookie('lowVisionColorName') : 'black,white';
    const lowVisionDisableImage = getCookie('lowVisionDisableImage') ? getCookie('lowVisionDisableImage') : 'on';
    const lowVisionLineHeight = getCookie('lowVisionLineHeight') ? getCookie('lowVisionLineHeight') : '1';
    const lowVisionfontFamily = getCookie('lowVisionfontFamily') ? getCookie('lowVisionfontFamily') : '1';

    if (lowVisionFontSize) { setFontSize(lowVisionFontSize); }
    if (lowVisionColorName) { setColor(lowVisionColorName); }
    if (lowVisionDisableImage) { enableDisableImage(getCookie('lowVisionDisableImage') === 'on'); }
    if (lowVisionLineHeight) { setLineHeight(lowVisionLineHeight); }
    if (lowVisionfontFamily) { setfontFamily(lowVisionfontFamily); }
  }
}

function disable() {
  document.cookie = 'lowVision=off; path=/';
  document.querySelector('html').style.fontSize = "16px";
  const panel = document.getElementById('sv_wrapper');
  panel.style.display = 'none';
  document.querySelector('body').classList.remove('tvsu-lowVisionColorEnable');
  document.documentElement.removeAttribute("style");

  const url = new URL(window.location.href);
  url.searchParams.delete('accessible');
  history.pushState({}, '', url);
}

export function lowVision() {
  init();

  const enableBtn = document.getElementById('lowVisible');
  enableBtn.addEventListener('click', (event) => {
    event.preventDefault();
    document.cookie = 'lowVision=on; path=/';
    const url = new URL(window.location.href);
    url.searchParams.set('accessible', 'true');
    history.pushState({}, '', url);
    init();
  });

  //font Size
  document.querySelectorAll('.tvsu-fs-outer button').forEach(el => {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      const fontSize = event.target.getAttribute('data-fontSize');
      document.cookie = `lowVisionFontSize=${fontSize}; path=/`;
      init();
    });
  });

  document.querySelectorAll('.tvsu-cs-outer button').forEach(el => {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      const bgName = event.target.getAttribute('data-bgName');
      const colorName = event.target.getAttribute('data-colorName');
      document.cookie = `lowVisionColorName=${bgName},${colorName}; path=/`;
      init();
    });
  });

  document.querySelectorAll('#img-onoff-btn').forEach(el => {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      const enable = !!getCookie('lowVisionDisableImage') && getCookie('lowVisionDisableImage') !== 'on';
      document.cookie = `lowVisionDisableImage=${enable ? 'on' : 'off'}; path=/`;
      init();
    });
  });

  document.querySelectorAll('.tvsu-line_height-outer button').forEach(el => {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      const value = event.target.getAttribute('data-fontSize');
      document.cookie = `lowVisionLineHeight=${value}; path=/`;
      init();
    });
  });


  document.querySelectorAll('.tvsu-font_family-outer button').forEach(el => {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      const value = event.target.getAttribute('data-fontFamily');
      document.cookie = `lowVisionfontFamily=${value}; path=/`;
      init();
    });
  });

  const closeBtn = document.getElementById('sv_close_btn');
  closeBtn.addEventListener('click', (event) => {
    event.preventDefault();
    disable();
  })
}
